import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router";
import OrbInput from "../../../../../shared/forms/orb-input";
import { useState } from "react";
import SyIcon from "../../../../../shared/components/sy-icon";
import styleSheet from "../style.module.scss";
import SyCard from "../../../../../shared/components/sy-card";
import { btnConfig, planetButtonConfig, userConfig } from "../community-config";
import THEME from "../../../../../shared/constants/app-theme.module.scss";
import SyDropdown from "../../../../../shared/forms/sy-dropdown";
import OrbButton from "../../../../../shared/components/orb-button";
import { getCookie } from "../../../../../utils/cookie";
import { getAuthDetails } from "../../../../../feature/auth-slice";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import planetService from "../../../services/planet-service";
import {
  getCommunityDetails,
  setDoc,
  setTimeLine,
} from "../../../../../feature/community-slice/community-slice";
import { useSearchParams } from "react-router-dom";
import { getCommunityValue } from "../helper";
import {
  communityParamPayload,
  setQueryParams,
} from "../../../../../utils/helper";
import { yupResolver } from "@hookform/resolvers/yup";
import { planetValidationSchema } from "../../../../../shared/components/schema-validation/schema-validation";
import SyPopup from "../../../../../shared/components/sy-model";
import AddContact from "../../../popups/add-contact-popup";
import AddDonate from "../../../popups/add-donate-popup";
import InviteCitizenPop from "../../../popups/invite-citizen-popup";
import OrbTextEditor from "../../../../../shared/forms/orb-text-editor";
import { useTranslation } from "react-i18next";
import { getImageDetails } from "../../../../../feature/image-slice";
import SySlider from "../../../../../shared/components/sy-slider";
import OrbImageSlider from "../../../../../shared/components/orb-image-slider";
import CommunityUpdateManage from "../community-updates-magement";
import AuthLayoutPopup from "../../../../auth-module/popup/auth-layout-popup";
import OrbConfirmation from "../../../../../shared/components/orb-confirmation";
import { useGetOrbitDetails } from "../../../../../utils/orbitdetails";
import { getPlanetDetails } from "../../../../../feature/planet-slice";
import SharePop from "../../../popups/share-popup";
import { OrbToast } from "../../../../../utils/orb-toast";

const CommunityManage = (props: any) => {
  const {
    onEngage,
    onHeal,
    onLike,
    updatePlanet,
    timeLineData,
    onCitizenInvite,
  } = props;

  const { planetData, planetStatus, planetAccess } =
    useSelector(getPlanetDetails);

  const { orbitId, planetId } = useParams();
  const [chipView, setChipView] = useState<boolean>(true);
  const [liked, setLiked] = useState<boolean>(planetData.like);
  const authToken = getCookie("auth_token");
  const [contactPopup, setContactPopup] = useState(false);
  const [authPopup, setAuthPopup] = useState(false);
  const [donatePopup, setDonatePopup] = useState(false);
  const imageSlice = useSelector(getImageDetails);
  const [showCitizenPop, setShowCitizenPop] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const [params, setParams] = useState<any>(getCommunityValue(searchParams));
  const dispatch = useDispatch();
  const [selectedPlanet, setSelectedPlanet] = useState<any>(null);
  const [selectedLand, setSelectedLand] = useState<any>(null);
  const [selectedBulding, setSelectedBulding] = useState<any>(null);
  const [openConfirmPopup, setConfirmPopup] = useState(false);
  const { t } = useTranslation();
  const { getDetail, isPending } = useGetOrbitDetails(true);
  const authDetails = useSelector(getAuthDetails);
  const communityDetail = useSelector(getCommunityDetails);
  const [shareOpen, setShareOpen] = useState(false);
  const [shareLoading, setShareLoading] = useState(false);
  const handleStatusFilter = () => void 0;
  const handleStatusLabel = (data: any) => data?.st_name;

  const getStatus = (id: any) => {
    const defaultStatus = planetStatus.find((data: any) => data?.st_id === id);
    return defaultStatus;
  };

  const defaultValues = {
    pro_id: planetData.pro_id,
    orb_id: Number(orbitId),
    pro_name: planetData.pro_name,
    pro_sub: planetData.pro_sub,
    pro_contact_name: planetData.pro_contact_name,
    pro_status_id: getStatus(planetData.pro_status_id),
    pro_contact_email: planetData.pro_contact_email,
    pro_contact_phone: planetData.pro_contact_phone,
    pro_desc: planetData.pro_desc,
    pro_owner: planetData.pro_owner,
    pro_address: planetData.pro_address,
    pro_img: "",
  };
  const {
    setValue,
    getValues,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    defaultValues: defaultValues,
    resolver: yupResolver(planetValidationSchema),
  });

  const formvalue = getValues();

  const onchangeView = () => {
    setChipView(false);
  };

  const onSubmit = (value: any) => {
    const payload = { ...value };
    const selectedImage: any = [];
    selectedImage.push(selectedPlanet, selectedLand, selectedBulding);
    payload.pro_img = selectedImage;
    payload.pro_status_id = payload.pro_status_id?.st_id;
    savePlanet(payload);
  };

  const onClickPlanetAction = (id: any) => {
    if (id === 1) {
      setLiked(!liked);
      onLike(!liked);
      onChangeLike();
    } else if (id === 2) {
      volunteerAdd();
    } else if (id === 3) {
      setDonatePopup(true);
    } else if (id === 4) {
      setShowCitizenPop(true);
    } else if (id == 5) {
      setConfirmPopup(true);
    } else if (id == 6) {
      setAuthPopup(true);
    } else if (id == 8) {
      OnJoinOrbit();
    } else if (id == 9) {
      onShare();
    }
  };

  const onCloseConfirmPop = () => {
    setConfirmPopup(false);
  };

  const onConfirmClick = (val: any) => {
    setConfirmPopup(false);
    if (val) {
      onDeletePlanet();
    }
  };

  const onShare = async (): Promise<void> => {
    if (shareLoading) return; // prevent double click

    setShareLoading(true);

    const shareUrl = window.location.href;

    try {
      if (navigator.share) {
        await navigator.share({
          title: planetData.pro_name,
          text: planetData.pro_sub || planetData.pro_desc,
          url: shareUrl,
        });
      } else {
        // fallback
        setShareOpen(true);
      }
    } catch (err) {
      // user cancelled or error → silent fail is fine
    } finally {
      setShareLoading(false);
    }
  };

  const onDeletePlanet = () => {
    deletePlanet(planetId);
  };

  const volunteerAdd = () => {
    const payload = {
      usr_id: authDetails.user_details.usr_id,
      orb_id: orbitId,
      pro_id: planetId,
      del: false,
    };
    addVolunteer(payload);
  };

  const { mutate: addVolunteer } = useMutation({
    mutationFn: planetService.addVolunteer,
    onSuccess(data, variables, context) {
      updatePlanet();
      if (!communityDetail.doc) {
        onEngage();
      }
    },
  });

  const OnJoinOrbit = () => {
    const payload = {
      pro_id: planetId,
      orb_id: orbitId,
      user_id: authDetails.user_details.usr_id,
    };
    joinOrbit(payload);
  };

  const { mutate: joinOrbit, isPending: joinOrbitLoading } = useMutation({
    mutationFn: planetService.joinOrbit,
    onSuccess(data, variables, context) {
      OrbToast(t(data.data.message), "top-right", "short", "default");
      updatePlanet();
    },
  });

  // const onCloseContact = (data: any) => {
  //   if (data == "save") {
  //     updatePlanet();
  //     if (!communityDetail.doc) {
  //       onEngage();
  //     }
  //   }

  //   setContactPopup(false);
  // };

  const onCloseAuthPop = (type: any = null) => {
    setAuthPopup(false);
    if (type === "save") {
      getDetail();
      updatePlanet();
    }
  };
  const onCloseSharePop = () => {
    setShareOpen(false);
  };

  const onChangeLike = () => {
    const payload: any = {
      pro_id: planetId,
      orb_id: orbitId,
    };
    getLike(payload);
  };

  const getEngage = (del: any = false) => {
    const payload: any = {
      pro_id: Number(planetId),
      orb_id: Number(orbitId),
    };
    if (del) {
      payload.del_id = authDetails.user_details.usr_id;
    } else {
      payload.usr_id = authDetails.user_details.usr_id;
    }

    // addVolunteer(payload);
  };

  const onSelectPlanet = (data: any) => {
    if (data) {
      const type = {
        id: data.id,
        type: 1,
      };
      setSelectedPlanet(type);
    }
  };

  const onSelectLand = (data: any) => {
    if (data) {
      const type = {
        id: data.id,
        type: 2,
      };
      setSelectedLand(type);
    }
  };
  const onSelectBulding = (data: any) => {
    if (data) {
      const type = {
        id: data.id,
        type: 3,
      };
      setSelectedBulding(type);
    }
  };

  // const { mutate: addVolunteer } = useMutation({
  //   mutationFn: planetService.addVolunteer,
  //   onSuccess(data, variables, context) {
  //     updatePlanet();
  //     if (!communityDetail.doc) {
  //       onEngage();
  //     }
  //   },
  // });

  const { mutate: savePlanet, isPending: saveLoading } = useMutation({
    mutationFn: planetService.savePlanet,
    onSuccess(data, variables, context) {
      setChipView(true);
      updatePlanet();
    },
  });

  const { mutate: getLike, isPending: likeLoading } = useMutation({
    mutationFn: planetService.setLike,
    onSuccess(data, variables, context) {
      updatePlanet();
    },
  });

  const { mutate: deletePlanet, isPending: planetDeleteLoading } = useMutation({
    mutationFn: planetService.deletePlanet,
    onSuccess(data, variables, context) {
      updatePlanet("close");
    },
  });

  const timeLine = () => {
    dispatch(setTimeLine(!communityDetail.timeLine));
    setQueryParams(
      communityParamPayload(!communityDetail.timeLine, communityDetail.doc)
    );
  };
  const doc = () => {
    dispatch(setDoc(!communityDetail.doc));
    setQueryParams(
      communityParamPayload(communityDetail.timeLine, !communityDetail.doc)
    );
  };

  const UserInfo = ({ contact, index }: any) => {
    const getChipValue = (name: any) => {
      return formvalue[name]?.st_name
        ? formvalue[name].st_name
        : formvalue[name];
    };
    return chipView ? (
      getChipValue(contact.formName) && (
        <div className={` ${styleSheet.chip_animate} pb-2 pe-2`}>
          <SyCard
            title={t(contact.placeHolder)}
            text={getChipValue(contact.formName)}
            chipColor={
              planetData?.images[1]?.id == 8
                ? "#7A9D54"
                : planetData?.images[1]?.id == 10
                ? "#BC6D27"
                : "#6c5d4c"
            }
          />
        </div>
      )
    ) : (
      <div
        className={`${styleSheet.field_style} ${styleSheet.input_animate}  p-2`}
      >
        <p className="mohave sub-font text-white m-0">
          {t(contact.placeHolder)}
        </p>
        <Controller
          name={contact.formName}
          control={control}
          render={({ field: { onChange, value } }) => {
            const errorMessage: any = errors[contact.formName]?.message ?? "";
            return contact.formName !== "pro_status_id" ? (
              <OrbInput
                type={"text"}
                value={value}
                onChange={onChange}
                errorMessage={t(errorMessage)}
              />
            ) : (
              <SyDropdown
                options={planetStatus}
                handleFilter={handleStatusFilter}
                handleChange={onChange}
                getoptlabel={handleStatusLabel}
                value={value}
                clearIcon={true}
              />
            );
          }}
        />
      </div>
    );
  };

  const onCloseDonate = (data: any) => {
    if (data == "save" && !communityDetail.doc) {
      onHeal();
    }
    setDonatePopup(false);
  };
  const onCitizenPopClose = (type: any) => {
    if (type === "save") {
      onCitizenInvite();
      // updatePlanet("citizen");
    }
    setShowCitizenPop(false);
  };

  const getPopupComponents = () => {
    return (
      <>
        <SyPopup
          open={openConfirmPopup}
          onClose={onCloseConfirmPop}
          maxWidth={"xs"}
        >
          <OrbConfirmation
            message={"are_you_sure_to_proceed_with_this_action"}
            onConfirmClick={onConfirmClick}
            buttons={btnConfig}
          />
        </SyPopup>
        <SyPopup open={authPopup} onClose={onCloseAuthPop} maxWidth={"sm"}>
          <AuthLayoutPopup onClose={onCloseAuthPop} view={"login"} />
        </SyPopup>

        <SyPopup open={shareOpen} onClose={onCloseSharePop} maxWidth={"xs"}>
          <SharePop onClose={onCloseSharePop}></SharePop>
        </SyPopup>
        {/* {contactPopup && (
          <SyPopup
            open={contactPopup}
            maxWidth={"md"}
            transitionDirection={"up"}
          >
            <AddContact close={onCloseContact} />
          </SyPopup>
        )} */}
        {donatePopup && (
          <SyPopup
            open={donatePopup}
            maxWidth={"lg"}
            fullScreen={true}
            transitionDirection={"up"}
          >
            <AddDonate close={onCloseDonate} />
          </SyPopup>
        )}
        {showCitizenPop && (
          <SyPopup open={showCitizenPop} maxWidth={"xs"}>
            <InviteCitizenPop onClose={onCitizenPopClose} />
          </SyPopup>
        )}
      </>
    );
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex-row d-flex mb-3">
          <div className="col">
            <div>
              {chipView ? (
                <div className={`${styleSheet.chip_animate}`}>
                  <h1 className=" m-0 bebas-neue text-white truncate-1-lines ">
                    {formvalue.pro_name}
                  </h1>
                </div>
              ) : (
                <div className={`${styleSheet.input_animate}`}>
                  <Controller
                    name={"pro_name"}
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      const errorMessage: any = errors.pro_name?.message ?? "";
                      return (
                        <OrbInput
                          placeholder={""}
                          value={value}
                          onChange={onChange}
                          type={"text"}
                          size={"sm-custom"}
                          errorMessage={t(errorMessage)}
                        />
                      );
                    }}
                  />
                </div>
              )}
              {chipView ? (
                <div className={`${styleSheet.chip_animate} `}>
                  <h5
                    className={`  m-0  mohave text-disabled  truncate-1-lines `}
                  >
                    {formvalue.pro_sub
                      ? formvalue.pro_sub
                      : "type your sub title here"}
                  </h5>
                </div>
              ) : (
                <div className={`${styleSheet.input_animate}`}>
                  <Controller
                    name={"pro_sub"}
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      const errorMessage: any = errors.pro_sub?.message ?? "";
                      return (
                        <OrbInput
                          placeholder={""}
                          value={value}
                          onChange={onChange}
                          type={"text"}
                          size={"xs-custom"}
                          errorMessage={t(errorMessage)}
                        />
                      );
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col d-flex justify-content-end align-items-end">
            {chipView ? (
              <div className={`${styleSheet.chip_animate}`}>
                {/* <SyIcon
                  name={"share"}
                  iconColor="white"
                  className="pointer me-2"
                  onClick={()=>onShare(true)}
                /> */}
                {(planetData.isAdmin || planetAccess == 1) && (
                  <SyIcon
                    name={"edit"}
                    iconColor="white"
                    className="pointer"
                    onClick={onchangeView}
                  />
                )}
              </div>
            ) : (
              (planetData.isAdmin || planetAccess == 1) && (
                <div className={`${styleSheet.input_animate}`}>
                  <button type="submit" className="unstyled-button">
                    <SyIcon
                      name={"save"}
                      iconColor="white"
                      className="pointer"
                      loading={saveLoading}
                    />
                  </button>
                </div>
              )
            )}
          </div>
        </div>
        <div className="d-flex flex-wrap ">
          {userConfig.map((contact: any, index: any) => {
            return (
              <div key={index}>
                <UserInfo contact={contact} index={index} />
              </div>
            );
          })}
        </div>

        <div className="">
          {chipView ? (
            <div
              className={`${styleSheet.chip_animate} mohave sub-font text-white m-0`}
            >
              <p
                className="mohave sub-font text-white m-0"
                dangerouslySetInnerHTML={{ __html: planetData.pro_desc }}
              />
            </div>
          ) : (
            <div className={`${styleSheet.input_animate}`}>
              <Controller
                name={"pro_desc"}
                control={control}
                render={({ field: { onChange, value } }) => {
                  return (
                    <OrbTextEditor
                      placeholder=""
                      value={value}
                      onChange={onChange}
                    />
                  );
                }}
              />
            </div>
          )}
        </div>
        {!chipView ? (
          <div className="d-flex py-5 gap-3 flex-wrap col">
            <OrbImageSlider
              image={imageSlice.planet}
              onSelected={onSelectPlanet}
              value={planetData.images[0].id}
            />

            <OrbImageSlider
              image={imageSlice.frame}
              onSelected={onSelectLand}
              value={planetData.images[1].id}
            />

            <OrbImageSlider
              image={imageSlice.object}
              onSelected={onSelectBulding}
              value={planetData.images[2].id}
            />
          </div>
        ) : (
          ""
        )}

        <div className="d-flex flex-wrap pt-3">
          {planetButtonConfig(liked, authDetails, planetData).map(
            (btn: any) => {
              return (
                btn.visible && (
                  <div className="p-1">
                    <OrbButton
                      className={" mohave "}
                      iconName={btn.icon}
                      iconType={btn.iconType}
                      value={btn.id}
                      iconStyle={btn?.iconStyle}
                      label={t(btn.label)}
                      iconColor={THEME[btn.color]}
                      loading={
                        likeLoading && btn.id === 1
                          ? true
                          : joinOrbitLoading && btn.id === 8
                          ? true
                          : shareLoading && btn.id === 9
                          ? true
                          :planetDeleteLoading &&  btn.id === 5
                            ? true
                          : false
                      }
                      onBtnClick={onClickPlanetAction}
                    />
                  </div>
                )
              );
            }
          )}
        </div>
      </form>

      {getPopupComponents()}
    </>
  );
};

export default CommunityManage;
